import classes from "./GoogleCalendarSection.module.css";

interface GoogleCalendarSectionProps {
  className?: string;
}

const GOOGLE_CALENDAR_EMBED_SRC =
  "https://calendar.google.com/calendar/embed?src=webkredit.aarau%40gmail.com&ctz=Europe%2FBelgrade&mode=WEEK&showTitle=0&showPrint=0&showTabs=0&showCalendars=0&showTz=0&wkst=2&hl=sr";

const GoogleCalendarSection = ({ className }: GoogleCalendarSectionProps) => {
  return (
    <section className={[classes.root, className].filter(Boolean).join(" ")}>
      <iframe
        title="Google calendar"
        src={GOOGLE_CALENDAR_EMBED_SRC}
        className={classes.iframe}
        frameBorder={0}
        scrolling="no"
        loading="lazy"
      />
    </section>
  );
};

export default GoogleCalendarSection;
